export function VsDiamond() {
  return (
    <div className="relative flex h-12 w-12 flex-shrink-0 items-center justify-center">
      <svg
        viewBox="0 0 48 48"
        className="pointer-events-none absolute inset-0 h-full w-full overflow-visible"
      >
        <line
          x1="2"
          y1="29"
          x2="19"
          y2="46"
          stroke="oklch(0.8 0.28 85)"
          strokeWidth="0.5"
        />
        <line
          x1="4"
          y1="33"
          x2="15"
          y2="44"
          stroke="oklch(0.8 0.28 85 / 0.4)"
          strokeWidth="0.5"
        />
        <line
          x1="29"
          y1="2"
          x2="46"
          y2="19"
          stroke="oklch(0.8 0.28 85)"
          strokeWidth="0.5"
        />
        <line
          x1="33"
          y1="4"
          x2="44"
          y2="15"
          stroke="oklch(0.8 0.28 85 / 0.4)"
          strokeWidth="0.5"
        />
      </svg>
      <div className="flex h-full w-full items-center justify-center bg-gradient-to-b from-[oklch(0.38_0.14_85)] to-[oklch(0.25_0.08_85)] [clip-path:polygon(50%_0%,100%_50%,50%_100%,0%_50%)]">
        <span
          className="font-display text-xs font-bold"
          style={{ color: "var(--accent)" }}
        >
          VS
        </span>
      </div>
    </div>
  )
}
